import { axios, getError, ReferenceHelper } from "../_helpers";
import { endpoints } from "./endpoints";

/**
 * Functions used to issue AJAX requests and manage responses.
 * All of the included methods use the Axios library for Promise-based requests.
 */
export const caseService = {
  getCaseTypes,
  getCaseCreationPage,
  createCase,
  getCase,
  updateCase,
  refreshCase,
  getPage,
  getView,
  cases,
  uploadAttachments,
  getAttachments,
  deleteAttachment,
  downloadAttachment,
  saveAttachments,
};

function getCaseTypes() {
  return axios
    .get(endpoints.BASEURL + endpoints.CASETYPES)
    .then(function (response) {
      return response.data.caseTypes;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function getCaseCreationPage(id) {
  return axios
    .get(endpoints.BASEURL + endpoints.CASETYPES + "/" + id)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function createCase(id, processID, content) {
  return axios
    .post(
      endpoints.BASEURL + endpoints.CASES,
      processID
        ? {
            caseTypeID: id,
            processID: processID,
            content: content,
          }
        : {
            caseTypeID: id,
            content: content,
          }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(error);
    });
}

function getCase(id) {
  return axios
    .get(encodeURI(endpoints.BASEURL + endpoints.CASES + "/" + id), {
      headers: {
        "Access-Control-Expose-Headers": "etag",
      },
    })
    .then(function (response) {
      response.data["etag"] = response.headers.etag;
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function updateCase(id, body, etag, action, pageInstr) {
  let actionParam = action ? { actionID: action } : null;

  return axios
    .put(
      encodeURI(endpoints.BASEURL + endpoints.CASES + "/" + id),
      pageInstr.postSettings.bUseEmbedPI || pageInstr.postSettings.bUseRepeatPI
        ? {
            content: ReferenceHelper.getPostContent(
              body,
              pageInstr.postSettings
            ),
            pageInstructions: pageInstr.pageInstructions,
          }
        : {
            content: ReferenceHelper.getPostContent(
              body,
              pageInstr.postSettings
            ),
          },
      {
        params: actionParam,
        headers: {
          "If-Match": etag,
        },
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function refreshCase(myCase, body) {
  return axios
    .put(
      encodeURI(
        endpoints.BASEURL +
          endpoints.CASES +
          "/" +
          myCase.ID +
          endpoints.REFRESH
      ),
      {
        content: body,
      },
      {
        headers: {
          "Access-Control-Expose-Headers": myCase.etag,
        },
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function getPage(caseID, pageID) {
  return axios
    .get(
      encodeURI(
        endpoints.BASEURL +
          endpoints.CASES +
          "/" +
          caseID +
          endpoints.PAGES +
          "/" +
          pageID
      )
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function getView(caseID, viewID) {
  return axios
    .get(
      encodeURI(
        endpoints.BASEURL +
          endpoints.CASES +
          "/" +
          caseID +
          endpoints.VIEWS +
          "/" +
          viewID
      )
    )
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function cases() {
  return axios
    .get(endpoints.BASEURL + endpoints.CASES)
    .then(function (response) {
      return response.data.cases;
    })
    .catch(function (error) {
      return Promise.reject(getError(error));
    });
}

function getAttachments(caseID) {
  return axios({
    method: "get",
    url: endpoints.BASEURL + `/cases/${caseID}/attachments`,
  })
    .then((attachments) => {
      return attachments.data;
    })
    .catch((error) => {
      console.log("The error is: ", error);
    });
}

function uploadAttachments(files) {
  const formData = new FormData();
  formData.append("appendUniqueIdToFileName", true);
  files.forEach((file) => {
    formData.append("arrayOfFiles", file);
  });
  return axios({
    method: "post",
    url: endpoints.BASEURL + "/attachments/upload",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  })
    .then((response) => ({
      type: "File",
      category: "File",
      ID: response.data.ID,
    }))
    .catch((error) => {
      console.log("The error is: ", error);
    });
}

function saveAttachments(data, caseID) {
  const attachmentData = { attachments: data };
  return axios({
    method: "post",
    url: endpoints.BASEURL + `/cases/${caseID}/attachments`,
    data: attachmentData,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("The error is: ", error);
    });
}

function deleteAttachment(file) {
  return axios({
    method: "delete",
    url: endpoints.BASEURL + `/attachments/${file.ID}`,
  }).then(() => {});
}

function downloadAttachment(file) {
  return axios({
    method: "get",
    url: endpoints.BASEURL + `/attachments/${file.ID}`,
  }).then((response) => {
    return response;
  });
}
